<div class="gpd-container gpd-full-page">
  <dx-validation-group class="vg-overview" id="vg-overview">
    <div class="overview-grid">
      <div class="overview-column">
        <div class="overview-column-header">
          <h3 i18n="@@phasesTitle">Phases</h3>
          <app-gpd-button
            icon="add"
            type="text"
            (click)="startAdd('phase')"
            i18n-title="@@addPhaseTitle"
            title="Add new phase"
          ></app-gpd-button>
        </div>
        <dx-scroll-view>
          <dx-sortable
            type="phase"
            class="overview-items"
            [data]="phases"
            handle=".drag-handle"
            [allowReordering]="!editState"
            milestone
            (onReorder)="onReorder($event)"
            (onDragEnd)="endDrag()"
            (onDragStart)="startReorder($event)"
            dragTemplate="drag-template"
            group="project-config"
            [allowDropInsideItem]="true"
            (onDragChange)="onDragMove($event)"
            dropFeedbackMode="push"
            (onAdd)="onReorder($event)"
          >
            <div *dxTemplate="let item of 'drag-template'" class="drag-template">
              <div
                [innerHTML]="item.itemElement.outerHTML | safeHTML"
                [style.width.px]="item.itemElement.scrollWidth"
              ></div>
            </div>
            @for (phase of phases; track phase.id; let phaseIndex = $index) {
              <app-phase-project-config-node
                [phase]="phase"
                [phases]="phases"
                [itemNumber]="phaseIndex + 1"
                [isEditing]="isEditing('phase', phaseIndex)"
                [isSelected]="phaseIndex === selectedPhaseIndex"
                [validationCallback]="getPhaseValidationCallback(phaseIndex)"
                (onStartEdit)="startEdit('phase', phaseIndex)"
                (onSave)="saveItem($event, 'phase')"
                (onCancel)="cancelEdit()"
                (onDelete)="deleteItem('phase', phaseIndex)"
                (onPhaseClick)="!disableClick && onPhaseClick(phaseIndex)"
              ></app-phase-project-config-node>
            }
          </dx-sortable>
        </dx-scroll-view>
      </div>

      <!-- Milestones Column -->
      <div class="overview-column">
        <div class="overview-column-header">
          <h3 i18n="@@milestonesTitle">Milestones</h3>
          <app-gpd-button
            *ngIf="selectedPhase"
            icon="add"
            type="text"
            (click)="startAdd('milestone', selectedPhaseIndex!)"
            i18n-title="@@addMilestoneTitle"
            title="Add new milestone"
          ></app-gpd-button>
        </div>

        <dx-scroll-view>
          <div *ngIf="!selectedPhase" class="no-selection-message">
            <p i18n="@@selectPhaseMessage">Select a phase to view its milestones</p>
          </div>
          <dx-sortable
            *ngIf="selectedPhase"
            type="milestone"
            class="overview-items"
            [data]="selectedPhase?.milestones || []"
            handle=".drag-handle"
            [allowReordering]="!editState"
            (onReorder)="onReorder($event)"
            (onDragStart)="startReorder($event)"
            (onDragChange)="onDragMove($event)"
            dragTemplate="drag-template"
            group="project-config"
            [allowDropInsideItem]="true"
            dropFeedbackMode="push"
            (onAdd)="onReorder($event)"
            (onDragEnd)="endDrag()"
          >
            <div *dxTemplate="let item of 'drag-template'" class="drag-template">
              <div
                [innerHTML]="item.itemElement.outerHTML | safeHTML"
                [style.width.px]="item.itemElement.scrollWidth"
              ></div>
            </div>
            @for (milestone of selectedPhase?.milestones || []; track milestone.id; let milestoneIndex = $index) {
              <app-milestone-project-config-node
                [milestone]="milestone"
                [phases]="phases"
                [itemNumber]="milestoneIndex + 1"
                [isEditing]="isEditing('milestone', milestoneIndex)"
                [isSelected]="milestoneIndex === selectedMilestoneIndex"
                [validationCallback]="getMilestoneValidationCallback(milestoneIndex)"
                (onStartEdit)="startEdit('milestone', milestoneIndex)"
                (onSave)="saveItem($event, 'milestone')"
                (onCancel)="cancelEdit()"
                (onDelete)="deleteItem('milestone', milestoneIndex)"
                (onMilestoneClick)=" !disableClick &&  onMilestoneClick(milestoneIndex)"
              ></app-milestone-project-config-node>
            }
          </dx-sortable>
        </dx-scroll-view>
      </div>

      <!-- Work Packages Column -->
      <div class="overview-column">
        <div class="overview-column-header">
          <h3 i18n="@@workPackagesTitle">Work Packages</h3>
          <app-gpd-button
            *ngIf="selectedPhase && selectedMilestone"
            icon="add"
            type="text"
            (click)="startAdd('task-package', selectedPhaseIndex!, selectedMilestoneIndex!)"
            i18n-title="@@addTaskPackageTitle"
            title="Add new task package"
          ></app-gpd-button>
        </div>
        <dx-scroll-view>
          <div *ngIf="!selectedPhase || !selectedMilestone" class="no-selection-message">
            <p *ngIf="!selectedPhase" i18n="@@selectPhaseForTasksMessage">
              Select a phase and milestone to view task packages
            </p>
            <p *ngIf="selectedPhase && !selectedMilestone" i18n="@@selectMilestoneMessage">
              Select a milestone to view its task packages
            </p>
          </div>
          <dx-sortable
            *ngIf="selectedPhase && selectedMilestone"
            type="task-package"
            class="overview-items"
            [data]="selectedMilestone?.taskPackages || []"
            handle=".drag-handle"
            [allowReordering]="!editState"
            (onReorder)="onReorder($event)"
            (onDragStart)="startReorder($event)"
            (onDragChange)="onDragMove($event)"
            dragTemplate="drag-template"
            group="project-config"
            dropFeedbackMode="indicate"
            (onDragEnd)="endDrag()"
          >
            <div *dxTemplate="let item of 'drag-template'" class="drag-template">
              <div
                [innerHTML]="item.itemElement.outerHTML | safeHTML"
                [style.width.px]="item.itemElement.scrollWidth"
              ></div>
            </div>
            @for (taskPackage of selectedMilestone?.taskPackages || []; track taskPackage.id; let taskIndex = $index) {
              <app-task-package-project-config-node
                [taskPackage]="taskPackage"
                [phases]="phases"
                [itemNumber]="taskIndex + 1"
                [isEditing]="isEditing('task-package', taskIndex)"
                [validationCallback]="getTaskValidationCallback(taskIndex)"
                (onStartEdit)="startEdit('task-package', taskIndex)"
                (onSave)="saveItem($event, 'task-package')"
                (onCancel)="cancelEdit()"
                (onDelete)="deleteItem('task-package', taskIndex)"
                (onTaskPackageClick)="onTaskPackageClick(taskPackage)"
                (onArchive)="onArchiveTaskPackage(taskPackage)"
                (onReactivate)="onReactivateTaskPackage(taskPackage)"
              ></app-task-package-project-config-node>
            }
          </dx-sortable>
        </dx-scroll-view>
      </div>
    </div>
  </dx-validation-group>
</div>

<app-generic-popup
  [(visible)]="deletePopupVisible"
  [title]="deletePopupTitle"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="deletePopupButtons"
  (onHiding)="onDeletePopupHiding()"
>
  <app-validation-toast
    state="Warning"
    [inline]="true"
    [htmlMessage]="deleteWarningMessage"
  ></app-validation-toast>

  @if (deleteReq?.moveToList?.length > 0) {
    <div class="delete-move-section">
      <p i18n="@@moveItemsToOptional">You can optionally move the contents to another location before deleting:</p>
      <dx-select-box
        class="gpd-input"
        [items]="deleteReq.moveToList"
        [(value)]="deleteReq.moveToId"
        [displayExpr]="'name'"
        [valueExpr]="'id'"
        [showClearButton]="true"
        i18n-placeholder="@@selectDestinationOptional"
        placeholder="Select destination (optional)"
        (onValueChanged)="onMoveToSelected($event.value)"
      ></dx-select-box>
    </div>
  }
</app-generic-popup>

<!-- Archive task package confirmation popup -->
<app-generic-popup
  [(visible)]="packageArchivePopupVisible"
  i18n-title="@@archiveTaskPackage"
  title="Aufgabenpaket archivieren"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="[
    { text: 'Abbrechen', type: 'secondary', onClick: cancelArchivePackage.bind(this) },
    { text: 'Archivieren', type: 'primary', onClick: confirmArchiveTaskPackage.bind(this) }
  ]"
>
  <p i18n="@@archiveTaskPackageDescription">Dieses Aufgabenpaket und alle enthaltenen Aufgaben werden bei neuen Projekten nicht mehr berücksichtigt. Das Aufgabenpaket wird aus dem Zeitplan entfernt, und alle Abhängigkeiten darauf werden dauerhaft gelöscht. Bestehende Projekte sind nicht betroffen.</p>
  @if (packageArchiveImpactTasks.length > 0) {
    <p i18n="@@archiveImpactDescription">Die folgenden Aufgaben haben Bedingungsregeln, die angepasst werden:</p>
    <ul>
      @for (t of packageArchiveImpactTasks; track t.taskId) {
        <li>{{ t.taskTitle }}</li>
      }
    </ul>
  }
</app-generic-popup>

<!-- Reactivate task package confirmation popup -->
<app-generic-popup
  [(visible)]="packageReactivatePopupVisible"
  i18n-title="@@reactivateTaskPackage"
  title="Aufgabenpaket reaktivieren"
  [allowOutsideClick]="false"
  [width]="480"
  [buttons]="[
    { text: 'Abbrechen', type: 'secondary', onClick: cancelReactivatePackage.bind(this) },
    { text: 'Reaktivieren', type: 'primary', onClick: confirmReactivateTaskPackage.bind(this) }
  ]"
>
  <p i18n="@@reactivateTaskPackageDescription1">Dieses Aufgabenpaket steht neuen Projekten wieder zur Verfügung.</p>
  <p i18n="@@reactivateTaskPackageDescription2">Bedingungsregeln, die Aufgaben dieses Pakets referenziert haben, wurden beim Archivieren entfernt und können nicht automatisch wiederhergestellt werden.</p>
  <p i18n="@@reactivateTaskPackageDescription3">Projekte, die während der Archivierung dieses Pakets erstellt wurden, erhalten diese Aufgaben nicht.</p>
</app-generic-popup>
